import { render, staticRenderFns } from "./post-comments.vue?vue&type=template&id=6810c7cc"
import script from "./post-comments.vue?vue&type=script&lang=js"
export * from "./post-comments.vue?vue&type=script&lang=js"
import style0 from "./post-comments.vue?vue&type=style&index=0&id=6810c7cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./post-comments.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports